import { connect } from "react-redux";
import LoginBox from "./login-box";
import { updatePersonalDateInfo, actionCreators } from "page/calendar/store";
import {
    actionCreators as uiActionCreators,
    getDomain,
    getShowLoginModal,
} from "ui/store";
import { actionCreators as userActionCreators } from "user/store";
import { ApplicationState } from "store";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    getResource: (key: string) => getResource(state, { key: key }),
    showLoginModal: getShowLoginModal(state),
    domain: getDomain(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
    login: userActionCreators.updateUser,
    updatePersonalDateInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginBox);
